<template lang="html">
  <div class="loading-box" v-show="show">
    <div>
      <i class="el-icon-loading"></i>
      <span>加载中...</span>
    </div>
  </div>
</template>

<script>
export default {
    name:'empty',
    props:{
      show:{type:Boolean,default:false}
    },
    data() {
        return {}
    }
}
</script>

<style scoped>
.loading-box{display:flex; min-height: 100%;}
.loading-box>div{margin:auto; font-size:2vw; color:#999; height:2.5vw; line-height:2.5vw; display:flex; align-items:center;}
.loading-box>div i{font-size:2.5vw; margin-right:0.5vw;}

@media (max-width: 991px){
.loading-box{display:flex; min-height: calc(100vh - 50vw - 55px);}
.loading-box>div{font-size:4vw; height:5.5vw; line-height:5.5vw;}
.loading-box>div i{font-size:5vw; margin-right:1vw;}
}
</style>

